import { useSelector } from 'react-redux';
import { useEffect, useRef } from 'react';
import { selectCurrentUser } from '../../slices/user/userSlice';
import { useSystemTheme } from '../../hooks/useSystemTheme';

interface FlashLoaderProps {
  visible: boolean;
}

const FlashLoader = ({ visible }: FlashLoaderProps) => {
  const currentUser = useSelector(selectCurrentUser);
  const flashLoaderRef = useRef<HTMLDivElement>(null);

  const systemTheme = useSystemTheme();

  useEffect(() => {
    const flashLoader = flashLoaderRef.current;
    if (!flashLoader) return;

    flashLoader.style.transition = 'opacity 0.25s';
    flashLoader.style.opacity = visible ? '1' : '0';
  }, [visible]);

  return (
    <div
      className="flash-loader"
      ref={flashLoaderRef}
      style={{
        ...(currentUser?.theme === 'dark' ||
        (currentUser?.theme === 'system' && systemTheme === 'dark')
          ? {
              background:
                'linear-gradient(67.73deg, #1b2934 5.33%, #05090e 117.24%)',
            }
          : {}),
        opacity: 1,
      }}
    />
  );
};

export default FlashLoader;
